import i18n from '@/plugins/i18n';
import router from '@/plugins/router';
import { App } from 'vue';
// import blocknative from '@/plugins/blocknative';
import { VueQueryPlugin } from '@tanstack/vue-query';
import VueVirtualScroller from 'vue3-virtual-scroller';

export function registerPlugins(app: App) {
  app
    .use(i18n)
    .use(router)
    .use(VueQueryPlugin)
    // .use(blocknative)
    .use(VueVirtualScroller);
  return app;
}
